module.exports = __webpack_public_path__ + "media/images/character-img-service-intro-event-c62f27b97cedf849ea9951e13af56e7b.png";